<template lang="pug">
  div
    table.table.table-striped.table-bordered
      tr
        td 1 Говорил ли Вам врач когда либо, что у Вас повышенное артериальное давление?
        td {{formatAnswer(data.body.content.is_high_blood_pressure, 1)}}
      tr
        td 2 Говорил ли Вам врач когда-либо, что у Вас имеется ишемическая болезнь сердца (стенокардия)?
        td {{formatAnswer(data.body.content.is_stenocardia, 1)}}
      tr
        td 3 Говорил ли Вам врач когда-либо, что у Вас имеется ишемическая болезнь сердца (инфаркт моикарда)?
        td {{formatAnswer(data.body.content.is_myocardial_infarction, 1)}}
      tr
        td 4 Говорил ли Вам врач когда-либо, что у Вас имеется цереброваскулярное заболевание (в т.ч. перенесенный инсульт)?
        td {{formatAnswer(data.body.content.is_cerebrovascular_disease, 1)}}
      tr
        td 5 Говорил ли Вам врач когда-либо, что у Вас имеется сахарный диабет или повышенный уровень глюкозы (сахара) в крови?
        td {{formatAnswer(data.body.content.is_diabetes, 1)}}
      tr
        td 6  Говорил ли Вам врач когда-либо, что у Вас имеются заболевания желудка и кишечника (хронический гастрит, язвенная болезнь, полипы)?
        td {{formatAnswer(data.body.content.is_stomach_disease, 1)}}
      tr
        td 7 Говорил ли Вам врач когда-либо, что у Вас имеется заболевание почек?
        td {{formatAnswer(data.body.content.is_kidney_disease, 1)}}
      tr
        td 8 Говорил ли Вам врач когда-либо, что у Вас имеется онкологическое образование?
        td {{formatAnswer(data.body.content.is_malignant_neoplasm, 1)}}

      tr(v-if='data.body.content.is_malignant_neoplasm !== undefined && data.body.content.is_malignant_neoplasm')
        td Если «Да», то какое?
        td {{formatAnswer(data.body.content.malignant_neoplasm, 2)}}
      tr
        td 9 Говорил ли Вам врач когда-либо, что у Вас имеется туберкулез легких?
        td {{formatAnswer(data.body.content.is_tuberculosis, 1)}}
      tr
        td 10 Был ли инфаркт миокарда у Ваших близких родственников (матери или родных сестер в возрасте до 65 лет или у отца, родных братьев в возрасте до 55 лет?)
        td {{formatAnswer(data.body.content.is_myocardial_infarction_relatives, 1)}}
      tr
        td 11 Был ли инсульт у Ваших близких родственников (матери или родных сестер в возрасте до 65 лет или у отца, родных братьев в возрасте до 55 лет?)
        td {{formatAnswer(data.body.content.is_cerebrovascular_disease_relatives, 1)}}
      tr
        td 12 Были ли у Ваших близких родственников в молодом или среднем возрасте или в нескольких поколениях злокачественные новообразования (рак желудка, кишечника, семейные полипозы)?
        td {{formatAnswer(data.body.content.is_malignant_neoplasm_relatives, 1)}}
      tr
        td 13 Возникает ли у Вас, когда Вы поднимаетесь по лестнице, идете в гору либо спешите или выходите из теплого помещения на холодный воздух, боль, ощущение давления, жжения или тяжести за грудиной или в левой половине грудной клетки с распространением в левую руку или без него?
        td {{formatAnswer(data.body.content.is_stress_pain, 1)}}
      tr
        td 14 Если Вы останавливаетесь, исчезает ли эта боль или эти ощущения в течение примерно 10 минут?
        td {{formatAnswer(data.body.content.stress_pain_passes, 3)}}
      tr
        td 15 Возникала ли у Вас когда-либо внезапная кратковременная слабость или неловкость при движении в одной руке или ноге или руке и ноге одновременно?
        td {{formatAnswer(data.body.content.is_limb_weakness, 1)}}
      tr
        td 16 Возникало ли у Вас когда-либо внезапное без видимых причин кратковременное онемение в одной руке, ноге или половине лица?
        td {{formatAnswer(data.body.content.is_short_numbness, 1)}}
      tr
        td 17 Возникала ли у Вас когда-либо кратковременная потеря зрения на один глаз?
        td {{formatAnswer(data.body.content.is_short_vision_loss, 1)}}
      tr
        td 18 Возникало ли у Вас когда-либо внезапно резкое головокружение или неустойчивость при ходьбе, в связи с чем Вы не могли идти, были вынуждены лечь, обратиться за посторонней помощью (вызвать скорую медицинскую помощь)?
        td {{formatAnswer(data.body.content.is_sudden_dizziness, 1)}}
      tr
        td 19 Бывают ли у Вас ежегодно периоды ежедневного кашля с отделением мокроты на протяжении примерно 3-х месяцев в году?
        td {{formatAnswer(data.body.content.is_recurrent_cough, 1)}}
      tr
        td 20 Бывало ли у Вас кровохарканье?
        td {{formatAnswer(data.body.content.is_hemoptysis, 1)}}
      tr
        td 21 Беспокоят ли Вас следующие жалобы в любых сочетаниях: боли в области верхней части живота (в области желудка), отрыжка, тошнота, рвота, ухудшение или отсутствие аппетита?
        td {{formatAnswer(data.body.content.is_stomachache, 1)}}
      tr
        td 22 Похудели ли Вы за последнее время без видимых причин (т.е. без соблюдения диеты или увеличения физической активности и пр.)?
        td {{formatAnswer(data.body.content.is_weight_loss_without_reason, 1)}}
      tr
        td 23 Бывает ли у Вас боль в области заднепроходного отверстия?
        td {{formatAnswer(data.body.content.is_inter_buttocks_pain, 1)}}
      tr
        td 24 Бывают ли у Вас кровяные выделения с калом?
        td {{formatAnswer(data.body.content.is_bloody_feces, 1)}}
      tr
        td 25 Бывает ли у Вас неоформленный (полужидкий) черный или дегтеобразный стул?
        td {{formatAnswer(data.body.content.is_looseness, 1)}}
      tr
        td 26 Курите ли Вы? (курение одной и более сигарет в день)
        td {{formatAnswer(data.body.content.is_smoking, 1)}}
      tr
        td 27 Вам никогда не казалось, что следует уменьшить употребление алкоголя?
        td {{formatAnswer(data.body.content.is_reduce_alcohol_consumption, 1)}}
      tr
        td 28 Испытываете ли Вы раздражение из-за вопросов об употреблении алкоголя?
        td {{formatAnswer(data.body.content.is_alcohol_questions_irritation, 1)}}
      tr
        td 29 Испытываете ли Вы чувство вины за то, как Вы пьете (употребляете алкоголь)?
        td {{formatAnswer(data.body.content.is_alcohol_guilt, 1)}}
      tr
        td 30 Похмеляетесь ли Вы по утрам?
        td {{formatAnswer(data.body.content.is_morning_hangover, 1)}}
      tr
        td 31 Сколько минут в день Вы тратите на ходьбу в умеренном или быстром темпе (включая дорогу до места работы и обратно)?
        td {{formatAnswer(data.body.content.walking_time, 3)}}
      tr
        td 32 Употребляете ли Вы ежедневно около 400 граммов (или 4-5 порций) фруктов и овощей (не считая картофеля)?
        td {{formatAnswer(data.body.content.is_plants_portion, 1)}}
      tr
        td 33 Обращаете ли Вы внимание на содержание жира и/или холестерина в продуктах при покупке (на этикетках, упаковках) или при приготовлении пищи?
        td {{formatAnswer(data.body.content.is_cholesterol_regard, 1)}}
      tr
        td 34 Имеете ли Вы привычку подсаливать приготовленную пищу, не пробуя ее?
        td {{formatAnswer(data.body.content.is_salt_food, 1)}}
      tr
        td 35 Потребляете ли Вы шесть и более кусков (чайных ложек) сахара, варенья, меда или других сладостей в день?
        td {{formatAnswer(data.body.content.is_sugar_consumption, 1)}}
      tr
        td 36 Выпиваете ли Вы или употребляете наркотики для того, чтобы расслабиться, почувствовать себя лучше или вписаться в компанию?
        td {{formatAnswer(data.body.content.is_narcotic_relax_consumption, 1)}}
      tr
        td 37 Вы когда-нибудь выпивали или употребляли наркотики, находясь в одиночестве?
        td {{formatAnswer(data.body.content.is_narcotic_consumption, 1)}}
      tr
        td 38 Употребляете ли Вы или кто-нибудь из Ваших близких друзей алкоголь или наркотики?
        td {{formatAnswer(data.body.content.is_relatives_narcotic_consumption, 1)}}
      tr
        td 39 Имеет ли кто-нибудь из Ваших близких родственников проблемы, связанные с употреблением наркотиков?
        td {{formatAnswer(data.body.content.is_relatives_narcotic_problem, 1)}}
      tr
        td 40 Случались ли у Вас неприятности из-за употребления алкоголя или наркотиков?
        td {{formatAnswer(data.body.content.is_narcotic_trouble, 1)}}
      tr
        td 41 Испытываете ли Вы затруднения при мочеиспускании?
        td {{formatAnswer(data.body.content.is_urination_problem, 1)}}
      tr
        td 42 Сохраняется ли у Вас желание помочиться после мочеиспускания?
        td {{formatAnswer(data.body.content.is_repeated_urination_desire, 1)}}
      tr
        td 43 Просыпаетесь ли Вы ночью, чтобы помочиться?
        td {{formatAnswer(data.body.content.is_wake_up_urination, 1)}}
      tr(v-if='(data.body.content.is_wake_up_urination !== undefined)&&(data.body.content.is_wake_up_urination)')
        td Если «да», то сколько раз за ночь Вы встаёте, чтобы помочиться?
        td {{formatAnswer(data.body.content.wake_up_urination_count, 2)}}


</template>
<script>
export default {
  props: ['data'],

  methods: {
    formatAnswer (fact, type) {
      switch (type) {
        case 1:
          return fact !== undefined ? (fact ? 'Да' : 'Нет') : '—'
        case 2:
          return fact || '—'
        case 3:
          return fact ? fact.name : '—'
      }
    }
  }
}
</script>
<style lang="sass" scoped>
@import "@/css/DocumentStyles.sass"
</style>
